import { v4 } from 'uuid';
import BaseModel from './BaseModel';

/** Group of form fields (single level — no nested groups in v1). */
class FormLayoutFieldGroup extends BaseModel {
    constructor(properties) {
        super(properties || {});

        if (!this.id) {
            this.id = v4();
        }

        if (!this.label || typeof this.label !== 'object') {
            this.label = {};
        }

        if (this.addRowLabel === undefined && this.add_row_label != null) {
            this.addRowLabel = this.add_row_label;
        }
        delete this.add_row_label;
        if (!this.addRowLabel || typeof this.addRowLabel !== 'object') {
            this.addRowLabel = {};
        }

        if (this.removeRowLabel === undefined && this.remove_row_label != null) {
            this.removeRowLabel = this.remove_row_label;
        }
        delete this.remove_row_label;
        if (!this.removeRowLabel || typeof this.removeRowLabel !== 'object') {
            this.removeRowLabel = {};
        }

        if ((this.stepId === undefined || this.stepId === null) && this.step_id != null) {
            this.stepId = this.step_id;
        }
        delete this.step_id;
        if (this.stepId === undefined) {
            this.stepId = null;
        }

        if (this.position === undefined || this.position === null) {
            this.position = 0;
        }
        if (this.multiple === undefined) {
            this.multiple = false;
        }

        const legacyMinItems = this.min_items;
        const legacyMaxItems = this.max_items;
        if (this.minItems === undefined || this.minItems === null) {
            this.minItems = legacyMinItems != null ? legacyMinItems : 1;
        }
        if (this.maxItems === undefined || this.maxItems === null) {
            this.maxItems = legacyMaxItems != null ? legacyMaxItems : 50;
        }
        delete this.min_items;
        delete this.max_items;
    }

    static getDefaultOptions() {
        return {
            id: v4(),
            name: 'group',
            label: {},
            addRowLabel: {},
            removeRowLabel: {},
            position: 0,
            multiple: false,
            minItems: 1,
            maxItems: 50,
            stepId: null,
        };
    }

    toPlainObject = () => JSON.parse(JSON.stringify(this));
}

export default FormLayoutFieldGroup;
